import AdminAutomaticPayouts from "./automaticPayouts";

export default AdminAutomaticPayouts;
